import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { contractChannelContract } from 'shared/domain/contract/contractChannelContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastContractError = makeErrorPublisher(contractChannelContract);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedContractError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedContractError', error, messageId, uniqueId);
  broadcastContractError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
